module.exports = __webpack_public_path__ + "img/icon-check-squared.ad26269a.svg";